<template>
  <div class="edit-profile-data-wrap">
    <p>
      You can edit your profile data here. The registration name will be shown in the audio plug-in editor in the left bottom corner. If you change the registration name you'll have to download and apply your licenses again in order to take effect. 
    </p>
    <form @submit.prevent="changeUserProfile">
      <Input type="text" label="First name" v-model="firstName"/>
      <Input type="text" label="Last name" v-model="lastName"/>
      <Input type="text" label="Registration name" v-model="registrationName"/>
      <input type="submit" class="fa-btn fa-btn-primary fa-btn-modal" value="Change details">
    </form>
    <ModalMessage :message="modalMessage"/>              
  </div>
</template>

<script setup>
import { ref, onMounted, computed, onBeforeMount, onUnmounted } from 'vue';
import APIClient from '/api/apiClient.ts';
import { useUserStore } from '/store/userStore.ts'; 
import { MessageType } from '@/types/enums.ts';
import { CSRFType } from '@/api/apiClient';
import CSRFManager from '~/utils/csrfManager.ts';

const csrfManager = new CSRFManager(CSRFType.UPDATE_USER_SETTINGS);
const csrfToken = computed(() => csrfManager.state.csrfToken);

onBeforeMount(async () => {
  await csrfManager.startFetchingToken();
});

onUnmounted(() => {
  csrfManager.stopFetchingToken();
});


const apiClient = APIClient.getInstance();

const userStore = useUserStore();

const firstName = ref('');
const lastName = ref('');
const registrationName = ref('');

const modalMessage = ref('');
const messageType = ref(MessageType.INFO);

onMounted(async () => {
  try {
    const response = await apiClient.fetchUserProfile();
    console.log(response, "fetchUserprofile");
    if (response.valid) {
      firstName.value = response.result.first_name;
      lastName.value = response.result.last_name;
      registrationName.value = response.result.registration_name;
      console.log("User profile fetched successfully!", firstName.value, lastName.value, registrationName.value);
    } else {
      console.error("Failed to fetch user profile:", response.error);
    }
  } catch (error) {
    console.error("An error occurred while fetching user data:", error);
  }
});

async function changeUserProfile() {
  try {
    modalMessage.value = "Processing...";
      messageType.value = MessageType.INFO;
    const response = await apiClient.updateUserProfile(firstName.value, lastName.value, registrationName.value, true, csrfToken.value);  
    if (response.valid) {
      console.log("Profile updated successfully!");
      userStore.setNewUserName(firstName.value + ' ' + lastName.value);
      modalMessage.value = "Profile updated successfully!";
      messageType.value = MessageType.SUCCESS;
    } else {
      console.error("Failed to update profile:", response.error);
      modalMessage.value = response.error; // or some other suitable error message
      messageType.value = MessageType.ERROR;
    }
  } catch (error) {
    console.error("An error occurred while updating user data:", error);
    modalMessage.value = "An unexpected error occurred. Please try again.";
    messageType.value = MessageType.ERROR;
  }
  csrfManager.fetchToken();
}

</script>
